/**
 * ReportUserTopBar
 *
 * Top bar for the ReportUserSheet stepper.
 * Shows a back arrow on the left (when back is possible), a title in the center,
 * and a close button on the right.
 */

import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { ReportTopBar } from '@/presentation/components/common/ReportTopBar';

export interface ReportUserTopBarProps {
  showBack: boolean;
  isLastStep: boolean;
  onBack: () => void;
  onClose: () => void;
}

export const ReportUserTopBar: React.FC<ReportUserTopBarProps> = ({
  showBack,
  isLastStep,
  onBack,
  onClose,
}) => {
  const { l10n } = useLocale();

  const title = isLastStep
    ? l10n.reportUser.submitStepTitle
    : l10n.reportUser.chooseReasonTitle;

  return <ReportTopBar title={title} showBack={showBack} onBack={onBack} onClose={onClose} />;
};
